export default __webpack_public_path__ + "styles/RichTextControl.4b481a55c76bed74f21bdf54275aacf8.css";